/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { MDDEResult } from "@sa/rep-mdde";
import { useDictionary, useOLAPTransformer, yearToCropYearFull, OLAPTransformerResult, useParameter } from "../../../shared";
import { dataService, dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe } from "../../../../charts/pipes";
import { SortingDirection } from "@sa/rep-common";
import { last } from "lodash";

const CATEGORIES_AXIS = "countries.default";
const SERIES_AXIS = "calendar.default";

export function useData1(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, countries] = useDictionary(dictionaryService, "slides-countries");
  const [, calendar] = useDictionary(dictionaryService, "slides-calendar");
  const [calendarParameter] = useParameter("@calendar");
  const options = useMemo(() => {
    if (!olapResult || !countries || !calendar) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsDictionaries: new Map([
        [CATEGORIES_AXIS, countries],
        [SERIES_AXIS, calendar],
      ]) as ReadonlyMap<string, Dictionary>
    }
  }, [olapResult, countries, calendar]);
  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${CATEGORIES_AXIS}.name`],
      rows: [`${SERIES_AXIS}.name`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${CATEGORIES_AXIS}.name`, `${SERIES_AXIS}.name`],
      },
      sorting: {
        axesByAttributes: {
          rules: []
        },
        rowsByValuesSorting: {
          rules: []
        },
        columnsByValuesSorting: {
          rules: [{
            measureId: 'value',
            selection: {
              "calendar.default": last(calendarParameter as string[]) !
            },
            direction: SortingDirection.Descending,
          }]
        }
      }
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
